
import Header from "./Header" ;
import LeftSideBare from "./LeftSideBare";
const Home=()=>{

    return <>
     <>
  <meta charSet="utf-8" />
  <meta content="width=device-width, initial-scale=1.0" name="viewport" />
  <style
    dangerouslySetInnerHTML={{
      __html:
        "@layer base{html,body{margin:0;padding:0;}body{overscroll-behavior:none;}main>:first-child{margin-top:0!important;}main>:last-child{margin-bottom:0!important;}}::-webkit-scrollbar{display:none;}"
    }}
  />
  <link
    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
    rel="stylesheet"
  />
  <link
    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght,FILL@100..700,0..1&display=swap"
    rel="stylesheet"
  />
  <link
    href="https://fonts.googleapis.com/css2?family=Hanken+Grotesk:wght@100..900&display=swap"
    rel="stylesheet"
  />
 <LeftSideBare />
  <div className="pr-[280px]">
    <Header />
    <main className="relative pt-16 min-h-screen bg-surface">
      <div className="flex flex-col w-full relative">
        {/* Header Section */}
        <div className="px-8 py-10 relative overflow-hidden bg-surface-container-low">
          <div className="absolute inset-0 bg-gradient-to-r from-primary/5 to-transparent pointer-events-none" />
          <div className="absolute -top-32 -left-32 w-96 h-96 bg-primary/5 rounded-full blur-3xl pointer-events-none mix-blend-multiply" />
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 relative z-10">
            <div>
              <div className="flex items-center gap-3 mb-2">
                <div className="w-1 h-6 bg-vibrant-orange rounded-full" />
                <span className="font-label-md text-label-md text-primary tracking-wider uppercase">
                  الإدارة المركزية
                </span>
              </div>
              <h1 className="font-headline-xl text-headline-xl text-on-surface mb-2">
                  تنبية
              </h1>
              <p className="font-body-lg text-body-lg text-on-surface-variant max-w-2xl">
               تنبية: حتى الان لايوجد اي محتوى يخص هذه الشاشة يمكنك استخدام القائمة الجانبية للتنقل بين الصفحات 
              </p>
            </div>
            {/* <div className="flex flex-wrap items-center gap-4">
              <button className="flex items-center gap-2 px-6 py-3 bg-surface text-primary border-2 border-primary/20 hover:bg-primary/5 rounded-full transition-all group">
                <span className="material-symbols-outlined text-[20px] transition-transform group-hover:-translate-y-1">
                  download
                </span>
                <span className="font-label-md text-label-md">
                  تصدير التقرير
                </span>
              </button>
              <button className="flex items-center gap-2 px-8 py-3 bg-vibrant-orange text-on-primary shadow-lg shadow-vibrant-orange/20 hover:shadow-xl hover:-translate-y-0.5 transition-all rounded-full group">
                <span className="material-symbols-outlined text-[20px] transition-transform group-hover:rotate-90">
                  add
                </span>
                <span className="font-label-md text-label-md">
                  تسجيل جمعية جديدة
                </span>
              </button>
            </div> */}
          </div>
        </div>
       
      </div>
    </main>
  </div>
</>

    </>
}
export default Home;